// ResizeHandle.js
import React from 'react';
import { PanelResizeHandle } from 'react-resizable-panels';
import styles from './ResizeHandle.module.css';

export default function ResizeHandle() {
  return (
    <PanelResizeHandle className={styles.ResizeHandle}>
      {/* Custom handle visuals */}
      <div className={styles.HandleBar} />
    </PanelResizeHandle>
  );
}
